import peppermintImage from 'images/peppermint_igloo_interior.jpg'
import reindeerImage from 'images/reindeer_igloo_interior.jpg'

const iglooData = [
        {
            id: 183,
            activityImage: reindeerImage,

            caption: 'Located near the Zoo&apos;s North Entrance and Glacier Bay Landing, this area offers 18 family-friendly igloos with cheerful holiday decor and fun activities to entertain children, making it a perfect retreat for families.',
            name: 'Reindeer Game Zone',
        },
        {
            id: 183,
            activityImage: peppermintImage,
            caption: 'Nestled outside the Lied Jungle, this area features 13 elegantly decorated igloos perfect for adults looking for a cozy, festive retreat. Enjoy a serene, twinkling winter wonderland with friends or for a romantic night out.',
            name: 'Peppermint Pines Zone',
        },
    ]
export default iglooData